(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eol-joan-fall-routine"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-add-joan-routine]');
    if (!button) return;
    const section = button.closest('[data-joan-routine]');
    const status = section.querySelector('[data-routine-status]');
    const ids = button.dataset.variantIds.split(',').filter(Boolean);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = 'Adding the routine…';
    try {
      const response = await fetch(section.dataset.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) })
      });
      if (!response.ok) throw new Error('Cart request failed');
      window.location.assign(section.dataset.cartUrl);
    } catch (error) {
      status.textContent = 'We could not add the full routine. Please add each available product below.';
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eol-video-pair"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-add-eol-pair]');
    if (!button) return;
    const section = button.closest('[data-eol-pair]');
    const status = section.querySelector('[data-pair-status]');
    const ids = button.dataset.variantIds.split(',').filter(Boolean);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = section.dataset.addingMessage;
    try {
      const response = await fetch(section.dataset.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) })
      });
      if (!response.ok) throw new Error('Cart request failed');
      window.location.assign(section.dataset.cartUrl);
    } catch (error) {
      status.textContent = section.dataset.errorMessage;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });

  } catch(e) { console.error(e); }
})();
})();
